<template>
  <v-card-title class="d-flex align-center position-relative">
    <slot name="title" v-bind="{ close }">
      <div class="text-h5 flex-fill">
        {{ title }}
      </div>
    </slot>
    <slot name="actions" v-bind="{ close }">
      <v-btn v-if="useClose" :disabled="disabled" icon small @click="close">
        <v-icon>$close</v-icon>
      </v-btn>
    </slot>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      color="primary accent-4"
    ></v-progress-linear>
  </v-card-title>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    useClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerValue: null
    };
  },
  watch: {
    value(val) {
      if (this.innerValue != val) this.innerValue = val;
    },
    innerValue(value) {
      if (this.value != value) this.$emit("input", value);
    }
  },
  methods: {
    close() {
      this.innerValue = false;
      this.$emit("close");
    }
  },
  mounted() {
    if (this.value) this.innerValue = this.value;
  }
};
</script>
